import React from 'react';
import styled from '@emotion/styled';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import PhoneAndroidOutlinedIcon from '@material-ui/icons/PhoneAndroidOutlined';

import { ButtonSlim, ButtonLink, Image } from '@Calix-Commerce/design-system/components';
import defaultAvatarImg from '@Calix-Commerce/design-system/assets/img/default-avatar.png';
import { ReactComponent as PhoneIcon } from '@Calix-Commerce/design-system/assets/svg/phone.svg';

import { CUSTOMER_OPS_EMAIL } from 'utils/constants';

import { PictureWrapper } from './styledComponents';

const InfoBlockStyled = styled.div`
  padding: 1.07rem;
  display: flex;
`;

const Title = styled.div`
  margin-bottom: ${({ hasAccountLead }) => (hasAccountLead ? '0.3rem' : '1rem')};
  margin-top: 0.2rem;

  white-space: nowrap;
`;

const Name = styled.div`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 1.9rem;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;

  svg {
    color: ${({ theme }) => theme.colors.primary};
    width: 1.08rem;
    height: 1.08rem;
    margin-right: 0.4rem;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.textDark};

    &:hover {
      text-decoration: underline;
    }
  }
`;

const parsePhoneToCta = (phone, international = false) => {
  const prefix = international ? '+1' : '';
  const parsedPhone = phone.replace(/[^0-9]/g, '');

  return `${prefix}${parsedPhone}`;
};

const InfoBlock = ({ accountLead, handleClose, handleContactClick }) => {
  const { mobilePhone, name, userImageUrl, workPhone } = accountLead;

  const hasAccountLead = accountLead.id;

  const title = hasAccountLead ? 'Your Customer Operations Representative' : 'Customer Operations';

  return (
    <InfoBlockStyled>
      <PictureWrapper>
        <Image src={userImageUrl || defaultAvatarImg} alt={title} fallbackSrc={defaultAvatarImg} />
      </PictureWrapper>
      <div>
        <Title hasAccountLead={hasAccountLead}>{title}</Title>
        {name && <Name>{name}</Name>}
        <InfoItem>
          <AlternateEmailIcon />
          <a href={`mailto:${CUSTOMER_OPS_EMAIL}`}>{CUSTOMER_OPS_EMAIL}</a>
        </InfoItem>
        {workPhone && (
          <InfoItem>
            <PhoneIcon />
            <a href={`tel:${parsePhoneToCta(workPhone, true)}`}>{workPhone}</a>
          </InfoItem>
        )}
        {mobilePhone && (
          <InfoItem>
            <PhoneAndroidOutlinedIcon />
            <a href={`tel:${parsePhoneToCta(mobilePhone)}`}>{mobilePhone}</a>
          </InfoItem>
        )}
        <div style={{ marginTop: hasAccountLead ? '1rem' : '2rem' }}>
          <ButtonSlim onClick={handleContactClick}>Contact</ButtonSlim>
          <ButtonLink onClick={handleClose}>Cancel</ButtonLink>
        </div>
      </div>
    </InfoBlockStyled>
  );
};

export { InfoBlock };
